import { Component, Vue } from 'vue-property-decorator'

export const scrollByHash = (hash: string, margin: number = 70): void => {
    let id = hash.replace(/^#/, '');
    let target = document.getElementById(id);
    window.scrollTo({top: (target?.offsetTop || 70) - margin});
}

@Component
class onScrollAnimationMixin extends Vue {
    protected isPageScrolled(): boolean {
        return window.scrollY > 5; // window.innerHeight * .1;
    }
    protected isTargetShown(): boolean {
        let areaBottom = window.innerHeight;
        let offset = this.$el.getBoundingClientRect().top;
        return 0 < offset && offset < areaBottom;
    }
    protected isTargetBelow(): boolean {
        return this.$el.getBoundingClientRect().top > window.innerHeight * .9;
    }
    protected isTargetInCenter(): boolean {
        let areaTop = window.innerHeight * .3;
        let areaBottom = areaTop + window.innerHeight * .3;
        let offset = this.$el.getBoundingClientRect().top;
        return areaTop < offset && offset < areaBottom;
    }
    protected animate(): void {}
    protected mount(): void {}

    mounted(): void {
        window.addEventListener('scroll', this.animate);
        this.mount();
    }
    destroyed(): void {
        window.removeEventListener('scroll', this.animate);
    }
}

@Component
export class onLoadJumpMixin extends Vue {

    DURATION = 750;

    protected scrollToByHash: Function = scrollByHash

    mounted(): void {
        setTimeout(() => {
            let hash = this.$route.hash;
            if (hash) {
                this.scrollToByHash(hash);
            }
        }, this.DURATION);
    }
}

export default onScrollAnimationMixin
